module.exports = {"450325100":"兴安镇","450325101":"湘漓镇","450325102":"界首镇","450325103":"高尚镇","450325104":"严关镇","450325105":"溶江镇","450325200":"漠川乡","450325201":"白石乡","450325202":"崔家乡","450325203":"华江瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450325.json
// module id = 2228
// module chunks = 0